import { inject } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot, CanDeactivateFn } from '@angular/router';

import { WizardComponent } from '../components/wizard/wizard.component';
import { EorderWizardService } from '../services/eorder-wizard.service';

export const eorderWizardExitGuard: CanDeactivateFn<WizardComponent> = async (
	_component: WizardComponent,
	_currentRoute: ActivatedRouteSnapshot,
	_currentState: RouterStateSnapshot,
	nextState: RouterStateSnapshot
) => {
	const eorderWizardService = inject(EorderWizardService);

	if (eorderWizardService.getState().isValid	&& nextState.url.includes('order/wizard')) {
		return true;
	}
	return eorderWizardService.actionExitWizard();
};
